import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyMask, phoneMask } from '~/utils/masks';

export const HeaderReportAproved = [
  {
    id: 1,
    value: 'Nome',
    maxChar: 11,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 11,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Proposta',
    maxChar: 11,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Aprovação',
    maxChar: 11,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Operador(a) de Venda',
    maxChar: 13,
  },
  {
    id: 6,
    value: 'Usuário',
    maxChar: 8,
  },
  {
    id: 7,
    value: 'Celular',
    maxChar: 11,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Canal',
    maxChar: 9,
    textAlign: 'center',
  },
  {
    id: 9,
    value: 'Valor limite',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 10,
    value: 'Motivo',
    maxChar: 10,
  },
  {
    id: 11,
    value: 'Nacionalidade',
    maxChar: 10,
    textAlign: 'center',
  },
  {
    id: 12,
    value: 'FaceDoc',
    maxChar: 9,
    textAlign: 'center',
  },
];

export const BodyReportApproved = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 14,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 11,
        textAlign: 'center',
      },

      {
        value: i.dataProposta
          ? moment(i.dataProposta).format('DD/MM/YYYY HH:mm')
          : '-',
        maxChar: 13,
        textAlign: 'center',
      },
      {
        value: i.dataAprovacao
          ? moment(i.dataAprovacao).format('DD/MM/YYYY HH:mm')
          : '-',
        maxChar: 13,
        textAlign: 'center',
      },

      {
        value: i.operador,
        maxChar: 12,
      },
      {
        value: i.nomeUsuarioMesa,
        maxChar: 8,
      },
      {
        value: phoneMask(i.celular).masked,
        maxChar: 12,
        textAlign: 'center',
      },
      {
        value: i.origem,
        maxChar: 9,
        textAlign: 'center',
      },
      {
        value: `R$ ${currencyMask(i.valorLimite)}`,
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: i.motivoReprovacao,
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: i.nacionalidade ? i.nacionalidade : '-',
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: i.forceFaceMatch
          ? 'Ignorado'
          : i.faceMatchCheckResponse?.status
            ? i.faceMatchCheckResponse.status.charAt(0).toUpperCase() +
            i.faceMatchCheckResponse.status.slice(1).toLowerCase()
            : '-',
        maxChar: 9,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};

export const BodyReportApprovedCSV = (data: any) => {
  const dataCSV = [];

  data.pagina?.forEach((i) => {
    dataCSV.push({
      ...i,
      faceDoc: i.forceFaceMatch
        ? 'Ignorado'
        : i.faceMatchCheckResponse?.status
          ? i.faceMatchCheckResponse.status.charAt(0).toUpperCase() +
          i.faceMatchCheckResponse.status.slice(1).toLowerCase()
          : '-',
    });
  });

  return dataCSV;
};
